export default class Position { 
	
	/**
	 * Generic position info / vector class
	 * @param {Object} args
	 * @param {Number} args.x
	 * @param {Number} args.y
	 * @param {Number} args.scale
	 * @param {Number} args.rotation in radians
	 * @param {Number} args.xv velocity
	 * @param {Number} args.yv velocity
	 * @param {Number} args.rv rotation velocity
	 */
	constructor(args = {x:0, y:0, scale:1, rotation:0, xv:0, yv:0, rv:0}) {
		this.x = args.x || 0;
		this.y = args.y || 0;
		this.scale = args.scale || 1;
		this.rotation = args.rotation || 0;
		this.xv = args.xv || 0;
		this.yv = args.yv || 0;
		this.rv = args.rv || 0;
		this.magnitude = 0;
		this.flipX = false;
		this.flipY = false;
	}

	drift(delta) {
		this.x += this.xv * delta;
		this.y += this.yv * delta;
		this.rotation += this.rv * delta;
	}

	getDistanceToOther(otherPosition) {
		let dx = otherPosition.x - this.x;
		let dy = otherPosition.y - this.y;
		return this.getVectorMagnitude(dx, dy);
	}

	getNormalToOther(otherPosition) {
		let dx = otherPosition.x - this.x;
		let dy = otherPosition.y - this.y;
		let dist = this.getVectorMagnitude(dx, dy);
		return { x:dx/dist, y:dy/dist, distance:dist }
	}

	getAngleToOther(otherPosition) {
		let n = this.getNormalToOther(otherPosition);
		return Math.atan2(n.y, n.x);
	}

	targetVelocityToOther(otherPosition, velocity) {
		let normal = this.getNormalToOther(otherPosition);
		this.xv = normal.x * velocity;
		this.yv = normal.y * velocity;
	}

	thrustToOther(otherPosition, thrust) {
		let normal = this.getNormalToOther(otherPosition);
		let dxv = this.xv - normal.x;
		let dyv = this.yv - normal.y;
		this.xv -= dxv * thrust;
		this.yv -= dyv * thrust;
	}

	getVectorMagnitude(x, y) {
		return Math.hypot(x, y)
	}

	updateVelocityMagnitude() {
		return this.magnitude = this.getVectorMagnitude(this.xv, this.yv);
	}

	orientToVelocity() {
		this.rotation = -Math.atan2(this.xv, this.yv) + Math.PI;
	}

}